<template>
  <el-dialog
    v-if="visible"
    :title="title"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      style="max-height: 600px;overflow: auto"
      :model="ruleForm"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="员工姓名："
        prop="staffName">
        <el-input
          v-model="ruleForm.staffName"
          show-word-limit
          :maxlength="12"></el-input>
      </el-form-item>
      <el-form-item
        label="微信手机号："
        prop="mobile">
        <el-input
          v-model="ruleForm.mobile"
          show-word-limit
          :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item
        label="邮箱地址："
        prop="email">
        <el-input
          v-model="ruleForm.email"
          show-word-limit
          :maxlength="50"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import OrgService from '@/service/org-service'
export default {
  name: 'EditOrgUserModal',
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { staffId: null, account: '', staffName: '', userType: 120, mobile: '', email: '', orgId: null },
      rules: {
        staffName: [
          { required: true, message: '请输入员工姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入微信手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.staffId ? '编辑' : '新增') + '机构员工'
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { staffId, account, mobile } = this.ruleForm
          const dispatch = staffId ? 'updatestaff' : 'addstaff'
          OrgService[dispatch]({ ...this.ruleForm, account: account || mobile })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    update(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
